module.exports = __webpack_public_path__ + "static/media/care.d6747f14.svg";